import { REMOVER_PERFIL_USUARIO } from '../types'

export default function removerPerfilUsuario (usuario, perfil) {
  return {
    type: REMOVER_PERFIL_USUARIO,
    payload: {usuario, perfil}
  }
}
